import { Heading } from '@miro-site/core';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var Title = function Title(props) {
  return /*#__PURE__*/_jsx(Heading, {
    as: "h1",
    $align: "center",
    $variant: ['h2', 'h0', 'h0', 'h0'],
    $mb: [16, 24, 24, 24],
    $mx: "auto",
    $styles: {
      maxWidth: [null, 851, 851, 851]
    },
    children: props.children
  });
};

export default Title;